import { PropsWithChildren, useEffect, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import { handleFirstLoad } from 'src/database/handleFirstLoad.ts';
import { handleRegularLoad } from 'src/database/handleRegularLoad.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { DatabaseProviderState } from 'src/database/types.ts';
import { SkeletonMainLayout } from 'src/modules/common/skeletons/SkeletonMainLayout/SkeletonMainLayout.tsx';

type Props = PropsWithChildren<{
    userSettings: UserSettings;
    uri: string;
    databaseCache: LocalForage;
    offlineDatabase: LocalForage;
    assetDomain: string;
}>

export const DatabaseProvider = ({
    offlineDatabase,
    databaseCache,
    uri,
    userSettings,
    assetDomain,
    children,
}: Props) => {
    const [state, setState] = useState<DatabaseProviderState | null>(null);

    useEffect(() => {
        handleFirstLoad(
            offlineDatabase,
            databaseCache,
            userSettings,
            uri,
            assetDomain,
        ).then((result) => {
            if (result !== false) {
                setState(result);
            } else {
                handleRegularLoad(
                    databaseCache,
                    userSettings,
                    uri,
                    (r: DatabaseProviderState) => {
                        setState(r);
                    },
                    assetDomain,
                    // eslint-disable-next-line no-console
                ).catch((err) => console.error(err));
            }
        });
    }, [offlineDatabase, databaseCache, userSettings, uri, assetDomain]);

    if (state === null) {
        return <SkeletonMainLayout breadcrumbs={false}/>;
    }
    return (
        <ApolloProvider client={state.apollo}>
            {children}
        </ApolloProvider>
    );
};
